const SelectConfig = (classSelect) => {

    // 1. Construtor de itens com bloqueio de tradução (evita "en" -> "em")
    function construct_li(src, text) {
        const langCode = text.toLowerCase().trim();
        return `
            <li data-lang="${langCode}" class="notranslate" translate="no">
                <img src="${src}" alt="" class="notranslate" />
                <p class="notranslate"><span class="notranslate" translate="no">${text}</span></p>
            </li>
        `;
    }

    // 2. Construtor da lista suspensa
    function construct_ul(options, classUL) {
        let LIs = '';
        options.forEach(option => {
            LIs += construct_li(
                option.getAttribute("data-icone"),
                option.value
            );
        });
        return `<ul class="${classUL} notranslate" translate="no">${LIs}</ul>`;
    }

    // 3. Injeção visual do componente no DOM
    function construct_element_select(selects, selectedOption, UL, className) {
        selects.forEach((select, i) => {
            const parent = select.parentElement;
            if (parent.querySelector(`.${className}`)) return;

            parent.insertAdjacentHTML('beforeend', `
                <div class='${className} ${className}-${i + 1} notranslate' translate="no">
                    <div class="select-option notranslate" translate="no">
                        <img src="${selectedOption.getAttribute("data-icone")}" class="notranslate" />
                        <p class="notranslate" translate="no">${selectedOption.value}</p>
                        <svg width="9" height="6" class="notranslate">
                            <path d="M4.64866 5.33482C4.56921 5.4231 4.43079 5.4231 4.35134 5.33482L0.300414 0.833793C0.18458 0.705089 0.275918 0.5 0.449072 0.5L8.55093 0.5C8.72408 0.5 8.81542 0.705088 8.69959 0.833793L4.64866 5.33482Z" fill="#6BB6EF"/>
                        </svg>
                    </div>
                    ${UL}
                </div>
            `);
        });
    }

    // 4. Lógica de Eventos Blindada (Resolve Clique Duplo e Erro de Cookie)
    function setupEvents(boxClass, ulClass, selectClass, classSelect) {
        const boxes = document.querySelectorAll(`[class*="${boxClass}"]`);
        
        boxes.forEach(box => {
            const selectOption = box.querySelector(`.${selectClass}`);
            const ul = box.querySelector(`.${ulClass}`);
            const svg = selectOption?.querySelector("svg");
            const selects = document.querySelectorAll(`${classSelect}`);
            console.log(selectOption)

            if (selectOption) {
                selectOption.onclick = (e) => {
                    e.stopPropagation();
                    const isActive = ul.classList.contains("active");
                    document.querySelectorAll(`.${ulClass}`).forEach(el => el.classList.remove("active"));
                    if (!isActive) {
                        ul.classList.add("active");
                        svg?.classList.add("active");
                    }
                    
                };
            }

            const options = box.querySelectorAll(`.${ulClass} li`);

            options.forEach(option => {

                option.addEventListener("click", (e)=>{
                    const lang = e.target.getAttribute("data-lang")
                    const paragraph = selectOption.querySelector("p");
                    if(paragraph){
                        paragraph.textContent = lang.toUpperCase();
                    }
                    
                })

                option.onclick = (e) => {
                    e.preventDefault();
                    e.stopPropagation();


                    const el = e.currentTarget;
                    const img = el.querySelector("img").src;
                    const langCode = el.getAttribute("data-lang"); 
                    const visibleText = el.querySelector("span").innerText;

                    // A. Atualiza UI Visual
                    selectOption.querySelector("img").src = img;
                    selectOption.querySelector("p").innerText = visibleText;
                    ul.classList.remove("active");
                    svg?.classList.remove("active");

                    // B. CORREÇÃO DO ERRO DE DOMÍNIO (Cookie manual)
                    // Limpamos e setamos o cookie no path correto para evitar rejeição do browser
                    document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    document.cookie = `googtrans=/pt/${langCode}; path=/;`; 

                    // C. SINCRONIA COM O GOOGLE (Evita clique duplo)
                    selects.forEach(select => {
                        // Resetamos o valor para garantir que o motor do Google dispare o evento
                        select.value = ""; 


                        setTimeout(() => {
                            select.value = langCode;
                            
                            // Disparamos o evento 'change' que o Google monitora
                            select.dispatchEvent(new Event('change', { bubbles: true }));
                            
                            // Salva preferência local
                            localStorage.setItem('language-abbreviation', langCode);
                        }, 150); 
                    });

                    // D. Caso especial PT (Restaurar Original)
                    if (langCode === 'pt') {
                        setTimeout(() => {
                            const frame = document.querySelector('.goog-te-banner-frame iframe');
                            if (frame) {
                                try {
                                    const innerDoc = frame.contentDocument || frame.contentWindow.document;
                                    const restoreBtn = innerDoc.querySelector('button[id*="confirm"]');
                                    if (restoreBtn) restoreBtn.click();
                                } catch (err) { /* Cross-origin protection */ }
                            }
                        }, 500);
                    }
                    
                };
            });
        });
    }

    function main() {
        const BoxName = "box-lang";
        const ULName = "ul_select_lang";
        const SelectOptionName = "select-option";

        const selects = document.querySelectorAll(`${classSelect}`);
        if (!selects.length) return;

        // Limpa instâncias duplicadas (previne erros do Parcel/HMR)
        document.querySelectorAll(`.${BoxName}`).forEach(el => el.remove());

        const options = Array.from(selects[0].options);
        const UL = construct_ul(options, ULName);

        const savedLang = localStorage.getItem('language-abbreviation') || 'pt';
        const selected = options.find(opt => opt.value.toLowerCase() === savedLang) || options[0];

        construct_element_select(selects, selected, UL, BoxName);
        setupEvents(BoxName, ULName, SelectOptionName, classSelect);
        
        // Fechar ao clicar fora
        document.removeEventListener("click", closeAll);
        document.addEventListener("click", closeAll);
    }

    function closeAll() {
        document.querySelectorAll(".ul_select_lang").forEach(u => u.classList.remove("active"));
        document.querySelectorAll(".select-option svg").forEach(s => s.classList.remove("active"));
    }

    // Inicialização robusta baseada no estado do carregamento
    if (document.readyState === "complete" || document.readyState === "interactive") {
        main();
    } else {
        window.addEventListener("load", main);
    }
};

export default SelectConfig;